import "core-js/modules/es.array.includes.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["aria-live"];
const _hoisted_2 = {
  class: "ds-surface-hint__text"
};
import { watch, onBeforeUnmount } from 'vue';
export default {
  __name: 'SurfaceHint',
  props: {
    message: {
      type: String,
      default: ''
    },
    tone: {
      type: String,
      default: 'info',
      validator: v => ['success', 'error', 'warning', 'info', 'pending'].includes(v)
    },
    /** 可选操作文案（如「去充值」） */
    actionLabel: {
      type: String,
      default: ''
    },
    /** 0 = 不自动隐藏 */
    autoHideMs: {
      type: Number,
      default: 0
    },
    /** 保留消息中的换行符 */
    preserveLines: {
      type: Boolean,
      default: false
    }
  },
  emits: ['hide', 'action'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    let hideTimer = null;
    function clearHideTimer() {
      if (hideTimer != null) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
    }
    function scheduleHide() {
      clearHideTimer();
      if (!props.message || props.autoHideMs <= 0) return;
      hideTimer = setTimeout(() => {
        hideTimer = null;
        emit('hide');
      }, props.autoHideMs);
    }
    watch(() => [props.message, props.autoHideMs], () => scheduleHide(), {
      immediate: true
    });
    onBeforeUnmount(clearHideTimer);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Transition, {
        name: "ds-surface-hint-fade"
      }, {
        default: _withCtx(() => [__props.message ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["ds-surface-hint", [`ds-surface-hint--${__props.tone}`, {
            'ds-surface-hint--preserve-lines': __props.preserveLines
          }]]),
          role: "status",
          "aria-live": __props.tone === 'error' ? 'assertive' : 'polite'
        }, [_createElementVNode("p", _hoisted_2, _toDisplayString(__props.message), 1), __props.actionLabel ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "ds-surface-hint__action",
          onClick: _cache[0] || (_cache[0] = $event => emit('action'))
        }, _toDisplayString(__props.actionLabel), 1)) : _createCommentVNode("", true)], 10, _hoisted_1)) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
};